var map = {
	"./bow.svg": 8152,
	"./collab.svg": 2244,
	"./demo.gif": 6112,
	"./feature-access.svg": 7040,
	"./feature-editor.svg": 9756,
	"./feature-workflow.svg": 8532,
	"./github.svg": 4125,
	"./heart.svg": 9584,
	"./helix.svg": 4160,
	"./play.svg": 4552,
	"./screenshot-content.png": 2548,
	"./screenshot-editor.jpg": 5648,
	"./screenshot-editor.png": 1180,
	"./screenshot-editorial.png": 5768,
	"./screenshot-identity.png": 4112,
	"./search.svg": 96,
	"./smashing-logo.svg": 3652,
	"./wavy-divider.svg": 4980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8664;